<template>
  <v-stepper-header style="box-shadow: none; max-width: 90vw;">
    <v-stepper-step
      step="B1"
      editable
      edit-icon="mdi-check"
      :complete="b1Complete"
      :class="$vuetify.breakpoint.name === 'xs' ? 'align-start' : ''"
    >
      Intro
    </v-stepper-step>

    <v-divider v-if="$vuetify.breakpoint.name !== 'xs'"></v-divider>

    <v-stepper-step
      step="B2"
      editable
      :class="$vuetify.breakpoint.name === 'xs' ? 'align-start' : ''"
      :edit-icon="b2Complete ? 'mdi-check' : 'mdi-minus'"
      :complete="b2Complete || bSteps[1] > 2"
      :complete-icon="b2Complete ? 'mdi-check' : 'mdi-minus'"
    >
      Contact
    </v-stepper-step>

    <v-divider v-if="$vuetify.breakpoint.name !== 'xs'"></v-divider>

    <v-stepper-step
      step="B3"
      editable
      :edit-icon="b3Complete ? 'mdi-check' : 'mdi-minus'"
      :complete="b3Complete || bSteps[1] > 3"
      :complete-icon="b3Complete ? 'mdi-check' : 'mdi-minus'"
      :class="$vuetify.breakpoint.name === 'xs' ? 'align-start' : ''"
    >
      Insurance
    </v-stepper-step>

    <v-divider v-if="$vuetify.breakpoint.name !== 'xs'"></v-divider>

    <v-stepper-step
      step="B4"
      editable
      :edit-icon="b4Complete ? 'mdi-check' : 'mdi-minus'"
      :complete="b4Complete || bSteps[1] > 4"
      :complete-icon="b4Complete ? 'mdi-check' : 'mdi-minus'"
      :class="$vuetify.breakpoint.name === 'xs' ? 'align-start' : ''"
    >
      General 1
    </v-stepper-step>

    <v-divider v-if="$vuetify.breakpoint.name !== 'xs'"></v-divider>

    <v-stepper-step
      step="B5"
      editable
      edit-icon="mdi-check"
      :class="$vuetify.breakpoint.name === 'xs' ? 'align-start' : ''"
    >
      General 2
    </v-stepper-step>

    <v-divider v-if="$vuetify.breakpoint.name !== 'xs'"></v-divider>

    <v-stepper-step
      step="B6"
      editable
      edit-icon="mdi-check"
      :class="$vuetify.breakpoint.name === 'xs' ? 'align-start' : ''"
    >
      Signature
    </v-stepper-step>
  </v-stepper-header>
</template>

<script>
export default {
  name: 'StepHeader',
  data: () => ({
    temp: null,
  }),
  computed: {
    textColor() {
      if (this.$vuetify.theme.dark) {
        return 'color: #ffffff';
      }

      return 'color: #2a4f66';
    },
    bSteps: {
      get() {
        return this.$store.state.benefitsStepper.currentStep;
      },
      set(value) {
        this.$store.commit('benefitsGoToStep', value);
      },
    },
    b1Complete() {
      const { documents } = this.$store.state.benefitsPacket;
      const BenefitsEmpCensus = documents.find((x) => x.category === 'BenefitsEmpCensus');
      const HealthBillingStatement = documents.find((x) => x.category === 'HealthBillingStatement');
      const BenefitsSummaryAndEnrollment = documents.find((x) => x.category === 'BenefitsSummaryAndEnrollment');
      const HealthInsuranceRatesAndRenewal = documents.find((x) => x.category === 'HealthInsuranceRatesAndRenewal');

      const benefitsProvided = this.$store.state.benefitsPacket.flags.benefitsAlreadyProvided;

      if (!benefitsProvided) {
        if (BenefitsEmpCensus) {
          return true;
        }
      }

      if (benefitsProvided
            && BenefitsEmpCensus
            && HealthBillingStatement
            && BenefitsSummaryAndEnrollment
            && HealthInsuranceRatesAndRenewal) {
        return true;
      }

      return false;
    },
    b2Complete() {
      const { benefitsAlreadyProvided } = this.$store.state.benefitsPacket.flags;

      if (benefitsAlreadyProvided) {
        return true;
      }

      return false;
    },
    b3Complete() {
      const { currentHealthCarrier } = this.$store.state.benefitsPacket;

      if (currentHealthCarrier.carrierName
            || currentHealthCarrier.renewalDate
            || currentHealthCarrier.policyNumber
            || currentHealthCarrier.insuranceInfoRates.length > 0) {
        return true;
      }

      return false;
    },
    b4Complete() {
      const { flags } = this.$store.state.benefitsPacket;

      if (flags.changedInsurers
          || flags.planCancelledOrDenied
          || flags.employeesOnCobra
          || flags.employeesinCobraElectionPeriod) {
        return true;
      }

      return false;
    },
  },
};
</script>

<style>
@media only screen and (max-width: 959.98px) {
  .v-stepper:not(.v-stepper--vertical) .v-stepper__label {
    display: unset;
  }
  .v-stepper:not(.v-stepper--vertical) .v-stepper__step__step {
    margin-left: 0;
    margin-right: 0;
  }
}
</style>
